import styled from 'styled-components';
import { Tooltip } from 'react-tooltip';
import { borderRadius, colourPalette, fontSize, lineHeight, padding, shadow } from 'styles/styles';

export const TooltipStyle = {
  Tooltip: styled(Tooltip)`
    background-color: ${colourPalette.neutral800};
    padding: ${padding.paddingXXS} ${padding.paddingSM};
    border-radius: ${borderRadius.roundedMD};
    max-width: 320px;
    box-shadow: ${shadow.shadowLG};
    font-size: ${fontSize.fontSizeSM};
    line-height: ${lineHeight.lineHeightMD};
    color: ${colourPalette.neutral0};
    opacity: 1 !important;
    z-index: 99;

    .react-tooltip-arrow {
      background: ${colourPalette.neutral800};
      width: 14px;
      height: 14px;
      border-radius: 2px;
      transform: rotate(45deg);
      z-index: -1;
    }
  `,
};
